import { CONFIG } from '../config';

interface RendererLike {
    getCanvasWidth(): number;
    getCanvasHeight(): number;
}

interface CanvasSize {
    width: number;
    height: number;
}

interface Point {
    x: number;
    y: number;
}

/**
 * Canvas 크기를 가져오는 유틸리티 함수
 * @param renderer - Renderer 인스턴스 (선택)
 */
export function getCanvasSize(renderer?: RendererLike): CanvasSize {
    if (renderer) {
        return {
            width: renderer.getCanvasWidth(),
            height: renderer.getCanvasHeight()
        };
    }
    return {
        width: CONFIG.CANVAS_WIDTH,
        height: CONFIG.CANVAS_HEIGHT
    };
}

/**
 * Canvas 좌표로 변환
 * @param clientX - 클라이언트 X 좌표
 * @param clientY - 클라이언트 Y 좌표
 * @param rect - Canvas bounding rect
 * @param renderer - Renderer 인스턴스
 */
export function toCanvasCoords(
    clientX: number,
    clientY: number,
    rect: DOMRect,
    renderer?: RendererLike
): Point {
    const canvasSize = getCanvasSize(renderer);
    const scaleX = canvasSize.width / rect.width;
    const scaleY = canvasSize.height / rect.height;
    return {
        x: (clientX - rect.left) * scaleX,
        y: (clientY - rect.top) * scaleY
    };
}
